import { useQuery } from '@tanstack/react-query';
import invariant from 'tiny-invariant';

import { Search } from '@air/api';
import { type Board } from '@air/api/types';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

const getPrivateCopyrightsListKey = ({
  workspaceId,
  search,
  boardId,
  libraryId,
}: {
  workspaceId: string | undefined;
  search: string;
  boardId: Board['id'] | undefined;
  libraryId: string | undefined;
}) => ['COPYRIGHTS', { workspaceId, search, boardId, libraryId }];

export const usePrivateCopyrightsList = ({
  search,
  boardId,
  libraryId,
}: {
  search: string;
  boardId: Board['id'] | undefined;
  libraryId: string | undefined;
}) => {
  const { currentWorkspace } = useCurrentWorkspace();

  const key = getPrivateCopyrightsListKey({ workspaceId: currentWorkspace?.id, search, boardId, libraryId });

  return useQuery({
    queryKey: key,

    queryFn: async () => {
      invariant(currentWorkspace?.id, 'Workspace ID is required');

      const data = await Search.getAssetVersionFilterLookups({
        limit: 20,
        boardId,
        workspaceId: currentWorkspace.id,
        field: 'copyright',
        search,
        libraryId,
      });

      return data.lookups.map((lookup) => lookup.value.toString());
    },
    enabled: !!currentWorkspace?.id,
  });
};
